/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as IdentityDefs from './defs.defs'

const $nsid = 'com.atproto.identity.resolveIdentity'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  identifier: /*#__PURE__*/ l.string({ format: 'at-identifier' }),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.payload(
  'application/json',
  /*#__PURE__*/ l.ref<IdentityDefs.IdentityInfo>(
    (() => IdentityDefs.identityInfo) as any,
  ),
)

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Resolves an identity (DID or Handle) to a full identity (DID document and verified handle). */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, [
  'HandleNotFound',
  'DidNotFound',
  'DidDeactivated',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
